import { render, staticRenderFns } from "./selfhandle-log.vue?vue&type=template&id=36947e3d"
import script from "./selfhandle-log.vue?vue&type=script&lang=js"
export * from "./selfhandle-log.vue?vue&type=script&lang=js"
import style0 from "./selfhandle-log.vue?vue&type=style&index=0&id=36947e3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports